export default __webpack_public_path__ + "static/media/tinyArrow.16f51216.svg";